export default __webpack_public_path__ + "static/media/weightlossregime_2@3x.0127ad21.jpg";